<template>
    <section class="plans flex-grow-1">
        <div class="titlelayoutLayout1" style="display: flex">
            <TitlePage
                title="Cupons"
                subtitle="Gerencie seus cupons de desconto"
                :hasMargin="true"
                class="p-4 p-md-1"
            />

            <v-btn
                variant="outlined"
                color="primary"
                rounded="2"
                border="2"
                :size="$vuetify.display.xs ? 'small' : 'large'"
                :icon="$vuetify.display.xs"
                class="text-none btnNew"
                @click="openNewCuponModal"
            >
                <template v-if="$vuetify.display.xs">
                    <v-icon>mdi-plus</v-icon>
                </template>
                <template v-else>
                    <v-icon start>mdi-plus</v-icon>
                    Novo Cupom
                </template>
            </v-btn>
        </div>
        <div class="plan">
            <div class="itens">
                <div
                    class="item couponItem"
                    v-for="(cupom, index) in cupons"
                    :key="index"
                >
                    <div class="itemContainerRow couponItem">
                        <div class="infoItemPlan couponItem">
                            <div class="title">
                                <h3
                                    :class="{
                                        expired: isExpired(
                                            cupom.expired,
                                            cupom.status
                                        ),
                                    }"
                                >
                                    {{ cupom.code }}
                                </h3>
                            </div>
                            <div class="description">
                                <p>
                                    <strong>{{ cupom.discount }}%</strong> em
                                    <strong>todos</strong> os planos
                                </p>
                            </div>
                        </div>
                        <div
                            class="expiration couponItem"
                            :class="{
                                expired: isExpired(cupom.expired, cupom.status),
                            }"
                        >
                            <span v-if="isExpired(cupom.expired, cupom.status)"
                                >Vencido em</span
                            >
                            <span v-else>Válido até</span>
                            <span
                                :class="{
                                    expired: isExpired(
                                        cupom.expired,
                                        cupom.status
                                    ),
                                }"
                                style="font-weight: 900"
                                >{{ formatDate(cupom.expired) }}</span
                            >
                        </div>
                        <div
                            class="status couponItem"
                            :class="{
                                expired: isExpired(cupom.expired, cupom.status),
                            }"
                        >
                            <span v-if="cupom.status == 1"
                                >Status:
                                <strong style="color: #160266">
                                    Ativo</strong
                                ></span
                            >
                            <span v-else
                                >Status:
                                <strong style="color: #adadad">
                                    Inativo</strong
                                ></span
                            >
                        </div>
                    </div>
                    <div class="actionsItem">
                        <button
                            class="btnIcon"
                            @click="openEditCuponModal(cupom)"
                        >
                            <fa icon="fa-pencil" />
                        </button>
                    </div>
                </div>
            </div>
            <!-- Paginação -->
            <div
                class="pagination"
                v-if="totalPages > 1"
                style="margin-top: 20px; display: flex; justify-content: center"
            >
                <button
                    :disabled="page === 0"
                    @click="changePage(page - 1)"
                    style="margin-right: 10px"
                >
                    Anterior
                </button>
                <span style="margin: 0 10px">
                    Página {{ page + 1 }} de {{ totalPages }}
                </span>
                <button
                    :disabled="page >= totalPages - 1"
                    @click="changePage(page + 1)"
                    style="margin-left: 10px"
                >
                    Próxima
                </button>
            </div>
        </div>
    </section>

    <v-dialog
        v-model="isNewCuponModalOpen"
        max-width="720"
        scrollable
        :persistent="newCuponFormSaving"
    >
        <v-card class="new-plan-modal-card">
            <v-card-title
                class="d-flex align-center justify-space-between text-wrap pr-2"
            >
                <span class="text-h6 font-weight-bold">Novo Cupom</span>
                <v-btn
                    icon
                    variant="text"
                    density="comfortable"
                    :disabled="newCuponFormSaving"
                    aria-label="Fechar"
                    @click="closeNewCuponModal"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-subtitle class="text-wrap pb-0">
                Crie um novo cupom para atrair novos clientes, criar campanhas de
                marketing e estabelecer parcerias.
            </v-card-subtitle>
            <v-divider class="mt-4" />
            <v-card-text class="pa-4 pa-md-6">
                <NewCuponForm
                    ref="newCuponFormRef"
                    layout="modal"
                    hide-heading
                    @saving-change="newCuponFormSaving = $event"
                    @success="onNewCuponSuccess"
                    @cancel="closeNewCuponModal"
                />
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog
        v-model="isEditCuponModalOpen"
        max-width="720"
        scrollable
        :persistent="editCuponFormSaving"
    >
        <v-card v-if="editingCuponId" class="new-plan-modal-card">
            <v-card-title
                class="d-flex align-center justify-space-between text-wrap pr-2"
            >
                <span class="text-h6 font-weight-bold">Editar Cupom</span>
                <v-btn
                    icon
                    variant="text"
                    density="comfortable"
                    :disabled="editCuponFormSaving"
                    aria-label="Fechar"
                    @click="closeEditCuponModal"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-subtitle class="text-wrap pb-0">
                Edite as informações do cupom
            </v-card-subtitle>
            <v-divider class="mt-4" />
            <v-card-text class="pa-4 pa-md-6">
                <EditCuponForm
                    :key="editingCuponId"
                    :cupom-id="editingCuponId"
                    layout="modal"
                    hide-heading
                    @saving-change="editCuponFormSaving = $event"
                    @success="onEditCuponSuccess"
                    @cancel="closeEditCuponModal"
                />
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
    import Cupom from '@/utils/Weflix/cupom';
    import { mapState } from 'vuex';
    import { toast } from 'vue3-toastify';
    import TitlePage from '@/components/Weflix/titlePage.vue';
    import NewCuponForm from '@/components/Weflix/Payment/NewCuponForm.vue';
    import EditCuponForm from '@/components/Weflix/Payment/EditCuponForm.vue';

    export default {
        data() {
            return {
                statusTrial: 'Desativado',
                isTrialActive: false,
                trialRange: [3, 3],
                modelValue: 0,
                cupons: [],
                isMobileIcon: false,
                page: 0,
                linesPerPage: 8,
                totalPages: 1,
                totalElements: 0,
                isNewCuponModalOpen: false,
                newCuponFormSaving: false,
                isEditCuponModalOpen: false,
                editingCuponId: null,
                editCuponFormSaving: false,
            };
        },
        components: {
            TitlePage,
            NewCuponForm,
            EditCuponForm,
        },
        mounted() {
            this.checkScreenSize();
            window.addEventListener('resize', this.checkScreenSize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.checkScreenSize);
        },
        computed: {
            ...mapState(['token']),
        },
        methods: {
            openNewCuponModal() {
                this.isNewCuponModalOpen = true;
                this.$nextTick(() => {
                    this.$refs.newCuponFormRef?.resetForm?.();
                });
            },
            closeNewCuponModal() {
                if (this.newCuponFormSaving) return;
                this.isNewCuponModalOpen = false;
            },
            async onNewCuponSuccess() {
                this.isNewCuponModalOpen = false;
                await this.getCupons();
                this.notify('Cupom criado com sucesso!', 'success');
                this.$nextTick(() => {
                    this.$refs.newCuponFormRef?.resetForm?.();
                });
            },
            openEditCuponModal(cupom) {
                this.editingCuponId = cupom.id;
                this.isEditCuponModalOpen = true;
            },
            closeEditCuponModal() {
                if (this.editCuponFormSaving) return;
                this.isEditCuponModalOpen = false;
                this.$nextTick(() => {
                    this.editingCuponId = null;
                });
            },
            async onEditCuponSuccess() {
                this.isEditCuponModalOpen = false;
                this.$nextTick(() => {
                    this.editingCuponId = null;
                });
                await this.getCupons();
            },
            notify(message, type = 'info') {
                toast(message, {
                    autoClose: 3000,
                    position: 'top-right',
                    theme: 'light',
                    limit: 1,
                    type: type,
                    dangerouslyHTMLString: true,
                });
            },
            changeStatusTrial() {
                this.statusTrial = this.isTrialActive
                    ? 'Ativado'
                    : 'Desativado';
            },
            async getCupons() {
                try {
                    const response = await Cupom.getCupons(
                        this.token,
                        this.page,
                        this.linesPerPage
                    );
                    this.cupons = response.content;
                    this.totalPages = response.totalPages || 1;
                    this.totalElements = response.totalElements || 0;
                } catch (error) {
                    console.error(error);
                }
            },
            changePage(newPage) {
                if (newPage >= 0 && newPage < this.totalPages) {
                    this.page = newPage;
                    this.getCupons();
                }
            },
            formatDate(isoDate) {
                const date = new Date(isoDate);
                const day = String(date.getUTCDate()).padStart(2, '0');
                const month = String(date.getUTCMonth() + 1).padStart(2, '0');
                const year = date.getUTCFullYear();

                return `${day}/${month}/${year}`;
            },
            isExpired(expirationDate, status) {
                const currentDate = new Date();
                const expDate = new Date(expirationDate);
                return status == 0 || currentDate > expDate;
            },
            checkScreenSize() {
                this.isMobileIcon = window.innerWidth <= 600;
            },
        },
        created() {
            this.getCupons();
        },
    };
</script>

<style scoped>
    .plans {
        position: relative;
    }

    button.btnNew {
        position: absolute;
        top: 20px;
        right: 20px;
    }

    .titlelayoutLayout {
        text-align: left;
        padding: 10px;
        border-bottom: 1px solid #e3e3e3;
        width: 100%;
        margin-bottom: 10px;
    }
    .item {
        background-color: #fbfbfb;
        padding: 9px 20px;
        border-radius: 5px;
        flex-direction: row;
        width: 100%;
        border: 1px dashed gray;
        align-items: center;
    }
    .title {
        display: flex;
        justify-content: left;
        gap: 10px;
        align-items: center;
    }
    .description {
        display: flex;
        gap: 5px;
        align-items: center;
    }

    .description p {
        margin: 0;
    }
    .itens {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
    }
    .title h3 {
        margin: 0;
        font-weight: 600;
    }
    .actionsItem {
        display: flex;
        align-items: center;
        gap: 35px;
    }
    .title span {
        font-size: 13px;
        font-weight: 200;
        color: gray;
        line-height: 15px;
    }
    .description p {
        margin: 0;
        font-size: 15px;
        color: #707173;
    }
    .description span svg {
        font-size: 15px;
        color: black !important;
    }
    .description span svg path {
        fill: black !important;
    }
    .titlelayoutLayout.seondary {
        margin-top: 20px;
        position: relative;
    }
    .itemAtionCollections.form-check.form-switch {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        gap: 50px;
        align-items: center;
    }
    .expiration {
        display: flex;
        flex-direction: column;
        gap: 0.2rem;
    }
    .pagination button {
        background: #fff;
        border: 1px solid #250891;
        color: #250891;
        border-radius: 4px;
        padding: 4px 12px;
        font-size: 16px;
        cursor: pointer;
        transition: all 0.2s;
    }
    .pagination button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
    .pagination button:not(:disabled):hover {
        background: #250891;
        color: #fff;
    }
</style>
<style>
    .description span svg path {
        fill: #535353 !important;
    }
    .itemAtionCollections .form-check-input {
        margin-right: 1rem !important;
        cursor: pointer;
        flex-shrink: 0;
        width: 3rem;
        height: 1rem;
        background-color: #d7d7d7;
        border: 1px solid #8d8d8d;
        box-shadow: none;
    }
    .v-slider-track__fill {
        background-color: rgb(37 8 145) !important;
    }
    .v-slider-thumb__surface.elevation-2 {
        background-color: #160266 !important;
    }
    .v-slider-thumb__label {
        background-color: #250891 !important;
    }

    button.btnIcon.active svg path {
        fill: #e5c519 !important;
    }
    .trial p {
        color: gray;
        margin: 0;
    }
    .warning {
        text-align: left;
        padding: 0px 15px;
        background-color: #f6f6f6;
        width: 555px;
        padding: 6px;
        border-radius: 5px;
        border: 1px solid #e7e7e7;
    }
    .sales span,
    .expiration.expired span {
        color: #adadad;
    }
    .actionsItem svg path {
        transition: all 500ms ease-in-out;
    }
    .actionsItem svg:hover path {
        fill: #250891;
        transition: all 500ms ease-in-out;
    }
    .item.couponItem {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 0.75rem;
    }
    .itemContainerRow.couponItem {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        gap: 0.75rem 1.25rem;
        flex: 1;
        min-width: 0;
        width: 100%;
    }
    @media (max-width: 600px) {
        button.btnNew {
            right: 12px;
        }
        .item.couponItem {
            gap: 0px;
        }
        .infoItemPlan.couponItem {
            display: flex;
            gap: 10px;
        }
        .expiration.couponItem {
            display: flex;
            gap: 5px;
        }
        .itemContainerRow.couponItem {
            display: flex;
            flex-direction: column;
            gap: 10px !important;
            align-items: baseline;
        }
        .infoItemPlan.couponItem {
            flex: 1 1 100%;
            max-width: 100%;
        }
    }
    h3.expired {
        color: gray;
    }
    .infoItemPlan.couponItem {
        display: flex;
        flex-direction: column;
        gap: 0.35rem;
        flex: 1 1 12rem;
        min-width: 0;
        width: auto;
        max-width: 100%;
    }
    .expiration.couponItem {
        flex: 0 0 auto;
    }
    .status.couponItem {
        flex: 0 0 auto;
        align-self: center;
    }
    .status.couponItem span {
        display: block;
    }
    .plan {
        padding: 10px;
    }
</style>
